export const MenuItems=[
    {
        title: "Home",
        url: "/",
        class__name: "nav__links",
        icon: "fa-solid fa-house-user"
    
    },
    {
        title: "About",
        url: "/about",
        class__name: "nav__links",
        icon: "fa-solid fa-circle-info",
    },
    {
        title: "Service",
        url: "/service",
        class__name: "nav__links",
        icon: "fa-solid fa-briefcase",
    },
    {
        title: "Contact",
        url: "/contact",
        class__name: "nav__links",
        icon: "fa-solid fa-address-book",
    }
]   